import React from 'react';
import Select from '@mos-front-components/public/es/components/MosSelect/MosSelect';

import renderSuggestion from '../helpers/renderSuggestion';
import { PersonFields } from '../../../../models/person';
import { PersonModel } from '../../../../selectors/addressUnmodeled';

interface StateProps {
  disabled: boolean;
  suggestions: PersonFields['address']['suggestions'];
  value: string;
  error: boolean | string;
}

interface OwnProps {
  model: PersonModel;
  placeholder: string;
}

interface DispatchProps {
  onInputChange(value, method, event): void;

  setFromSuggest(value): void;
}

export type AddressSuggestProps = StateProps & DispatchProps & OwnProps;

function AddressSuggest(props: AddressSuggestProps): JSX.Element {
  return (
    <div className="PguFormGrid__row">
      <Select
        disabled={props.disabled}
        className="PguFormGrid__field PguFormGrid_col ym-hide-content"
        placeholder={props.placeholder}
        onInputChange={props.onInputChange}
        suggestions={props.suggestions}
        onChange={props.setFromSuggest}
        renderSuggestion={renderSuggestion}
        value={props.value || ''}
        hasError={props.error}
        withClear
      />
    </div>
  );
}

export default AddressSuggest;
